/**
 * Backend API base URL for browser requests.
 * When frontend is served on port 3000 (PM2) and backend on 3001, requests must target 3001.
 * REACT_APP_API_BASE_URL (build-time) overrides when set.
 */
export function getApiBaseUrl(): string {
  if (typeof window === 'undefined') return '';
  const buildTimeUrl = process.env.REACT_APP_API_BASE_URL;
  if (buildTimeUrl) return buildTimeUrl.replace(/\/$/, '');
  if (process.env.NODE_ENV !== 'production' && window.location.hostname === 'localhost') {
    return 'http://localhost:5050';
  }
  if (window.location.port === '3000') {
    return `${window.location.protocol}//${window.location.hostname}:3001`;
  }
  return '';
}
